import cn from 'classnames';
import type React from 'react';
import { useRef, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { usePersonalRedirect } from '@pages/personal/model.ts';
import { useSupportPageRedirect } from '@pages/support/model.ts';
import {
  ArticleShort,
  Cart,
  Chat,
  Exit,
  Lear,
  Notifications,
  Patient,
  Person,
  Phone,
  Private,
  Program,
  SecurityIconMenu,
  SpecialistProfile,
  StatisticIconMenu,
  Statistics,
  Terms,
} from '@shared/assets/icons';
import { getFullNameM } from '@shared/helpers';
import { useResetPasswordModal } from '@src/modules/Authentication/frames/reset-password-form/model.ts';
import { useUser } from '@src/shared/hooks/use-user.ts';
import useOutsideClick from 'library/hooks/common/useOutsideClick';
import useMenulinks from 'library/hooks/header/useMenuLinks';
import * as st from './styles.module.scss';

const icons: Record<string, ReactNode> = {
  articles: <ArticleShort />,
  consultations: <Chat />,
  schedules: <Chat />,
  clients: <Patient />,
  patients: <Patient />,
  exit: <Exit />,
  events: <Lear />,
  notification: <Notifications />,
  video: <Program />,
  programs: <Program />,
  store: <Cart />,
  store_stat: <Statistics />,
  profile: <Person />,
  privacy: <Private />,
  specialists: <SpecialistProfile />,
  support: <Phone />,
  terms: <Terms />,
  statistics: <StatisticIconMenu />,
};

export const ProfileMenu: React.FC = () => {
  const links = useMenulinks();
  // const { user } = useUser();
  const { user } = useUser();
  const { openResetPasswordModal } = useResetPasswordModal();

  const buttonRef = useRef(null);
  const listRef = useRef(null);

  const handleOusideClick = () => {
    links.setShowMenu(false);
  };

  const { savePersonalPrevPageUrl } = usePersonalRedirect();
  const { doSavePageUrl } = useSupportPageRedirect();
  useOutsideClick([buttonRef, listRef], handleOusideClick);
  return (
    <div className={st.profile}>
      <button
        className={cn(st.profile__button, links.showMenu && st.active)}
        onClick={() => links.setShowMenu(true)}
        ref={buttonRef}
      >
        <Person />
      </button>

      {links.showMenu && (
        <div className={st.profile__menu} ref={listRef}>
          <div className={st.profile__user}>
            {user?.photo ? (
              <img src={user?.photo} alt="" className={st.profile__photo} />
            ) : (
              <Person />
            )}
            <span className={st.profile__name}>
              {user ? getFullNameM(user?.first_name, user?.middle_name, user?.last_name) : ''}
            </span>
          </div>

          {/*<hr className={st.line} />*/}
          <div className={cn(st.br, st.brWithLine)} />
          <div className={st.br} />

          <Link className={st.profile__item} to={`/personal`} onClick={savePersonalPrevPageUrl}>
            {icons['profile']}
            <span className={st.profile__text}>Профиль</span>
          </Link>

          <Link className={st.profile__item} to={`/support`} onClick={doSavePageUrl}>
            {icons['support']}
            <span className={st.profile__text}>Техническая поддержка</span>
          </Link>

          {links.userModules.map((link) => (
            <button
              className={st.profile__item}
              key={link.code}
              onClick={() => links.handleButtonClick(link.code)}
            >
              {icons[`${link.code}`]}
              <span className={st.profile__text}>{link.verbose_name}</span>
            </button>
          ))}

          {links.sortedModules.map(
            (link) =>
              link.module_type === 'statistics' && (
                <button
                  className={st.profile__item}
                  key={link.code}
                  onClick={() => links.handleButtonClick('/store_stat')}
                >
                  {icons[`${link.module_type}`]}
                  <span className={st.profile__text}>{link.verbose_name}</span>
                </button>
              )
          )}
          <button
            className={st.profile__item}
            onClick={() => {
              openResetPasswordModal();
              handleOusideClick();
            }}
          >
            <SecurityIconMenu />
            <span className={st.profile__text}>Безопасность</span>
          </button>

          {/*<a*/}
          {/*	className={st.profile__item}*/}
          {/*	href="https://api.academia-rs.com/agreement/"*/}
          {/*	target="_blank"*/}
          {/*	rel="noreferrer"*/}
          {/*>*/}
          {/*	<AgreementIconMenu />*/}
          {/*	<span className={st.profile__text}>Соглашение</span>*/}
          {/*</a>*/}

          {links.staticLinks.map((link) => (
            <button
              className={cn(st.profile__item, st.logoutButton)}
              onClick={link.onClick}
              key={link.code}
            >
              {icons[`${link.code}`]}
              <span className={cn(st.profile__text, st.text)}>{link.title}</span>
            </button>
          ))}
          {/* {links.showStatistics ? links.showStatistics : null} */}
        </div>
      )}
    </div>
  );
};
